import { Injector } from '@angular/core';

export default abstract class Migration {
  constructor(public readonly number: number) {}

  public abstract up(injector: Injector): Promise<void>;
}
